"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteSignature = void 0;
var RouteSignature;
(function (RouteSignature) {
    RouteSignature.accountAgentGetPerms = "DGQRbf4xgB#pNP?=~DXI";
    RouteSignature.accountAgentGrant = "Evc0<UWw)L-u&DXC>g*7";
    RouteSignature.accountAgentRevoke = "Evc0<UWw)L-u&DXC>g*7";
    RouteSignature.accountBeACreator = "EZ0-#*8&%`mU2}a5_u9K";
    RouteSignature.accountChangeUsername = "kY2*KH~14jg=Y?|8G=+Q";
    RouteSignature.accountCommunicationPreferenceGet = "!#0t4$}?LmR@meSIw^f>";
    RouteSignature.accountCommunicationPreferenceSet = "xtIsL(;6&YH<$KU&_<us";
    RouteSignature.accountDeregisterPushNotifDeviceToken = "2A(ftmR^D43Z!<2J*su8";
    RouteSignature.accountExplodingTokenForWebSession = "pW1kDe^RKD7q>m)i-5?y";
    RouteSignature.accountForgotPassword = "UA4bEx|_(-gBjiu=$v&|";
    RouteSignature.accountGetChromeExtensionInfo = "B3)<*<<i1bs^gI6Rtiw-";
    RouteSignature.accountNotificationDevicePolicyGet = "643^7q{l#9fB<%6uob+?";
    RouteSignature.accountNotificationDevicePolicySet = "V#fbQMeHsU5zYdwj$Wl@";
    RouteSignature.accountOnboardingDone = "@*@%F<Jvxc;<Fjx`~QJ-";
    RouteSignature.accountRegisterByEmail = "Mb;4s=C~qSQu<3u2R%44";
    RouteSignature.accountRegisterPushNotifDeviceToken = "dnAW6H|q8Zs~xec*7ctV";
    RouteSignature.accountResetPassword = "*BrW^^B(c8)rOckYn1Df";
    RouteSignature.accountRestrict = "uoXvP0Im#&6j2x;od%s`";
    RouteSignature.accountSeppuku = "B_nN)@LL$Ku@+r106cwT";
    RouteSignature.accountTokenFromAppleSignIn = "Gk7uUKxnDopXAt%g(){y";
    RouteSignature.accountTokenFromGoogleSignin = "K_KUuW`}_IC*(i}IlZ}X";
    RouteSignature.accountTokenFromLogin = "uNopCTz-ZhDMkvimjSv4";
    RouteSignature.accountTokenFromWebSession = "EbU2w+OGVLTC}&=_NwAl";
    RouteSignature.accountVerifyEmail = "!ev1eo9A_WiT+yGN7qj>";
    RouteSignature.billingStripeCreateCheckoutSession = "3Foo3GdNWP54%ENQ9L=R";
    RouteSignature.billingSubscriptionEnd = "d)HP&_QqDONCuEM63KS@";
    RouteSignature.billingSubscriptionGetStatus = "<(w;!3JZV4oXEC)FcDyY";
    RouteSignature.billingSubscriptionGetStatus2 = "ZhHv9-8XBUS<;A`N@t&4";
    RouteSignature.billingTippingPeriodStatementAll = ";Jm_xDx}on9k4{hHS~tZ";
    RouteSignature.billingTippingPeriodStatementCurrent = "k!?lvA~A+qv5Ne;+fPuJ";
    RouteSignature.creatorCreate = ";2Eg)ANmn_FVMZ&Qp;GJ";
    RouteSignature.creatorDomainAttributionAdd = "TgA)tj8GnDz+n3NhywFD";
    RouteSignature.creatorDomainAttributionAll = "A?5f%_n??uWsR0$W&fq|";
    RouteSignature.creatorGet = "i>6E!lG8f)qzmyHW*idT";
    RouteSignature.creatorPairUserAndCreator = "z(1vHcL@2umUlw=eMq46";
    RouteSignature.creatorSearch = "WP*dL*mvVm3ydFty&rDb";
    RouteSignature.creatorTagAdd = "+I%3J9)3OseKC@eUon!5";
    RouteSignature.creatorTagRemove = "+I%3J9)3OseKC@eUon!5";
    RouteSignature.creatorUrlPrefixAttributionAdd = "(prJN;X$!T?`>9uG~xXI";
    RouteSignature.creatorUrlPrefixAttributionAll = "=G3}4+|9N;8(FEAH*)x?";
    RouteSignature.creatorYoutubeChannelAttributionAdd = "(ymwbYcaRqUc3^uX)M%e";
    RouteSignature.creatorYoutubeChannelAttributionAll = "`A-(axk-+POrEPDVVmZq";
    RouteSignature.creatorAccountAcceptTos = "H%&HRylRk7E@_ye%f8~n";
    RouteSignature.creatorAccountAddWorkToWorksFeed = "4n#94S+sIdCiYt~iS)a7";
    RouteSignature.creatorAccountCreatorOfAll = "c=fD8u+b5;OYJ?{gonD^";
    RouteSignature.creatorAccountCreatorOfGet = "&3^^$qpdcdy~$#oj{<CY";
    RouteSignature.creatorAccountDemoteFromPrimaryWorks = "I}14;0G-VlXL^s(`+<Bu";
    RouteSignature.creatorAccountGetRevenueForDay = "><Z8b^lx9uAT{Og1Y3aN";
    RouteSignature.creatorAccountGetRevenueForPastWeek = "2BLO(ovA>e%7h{u7fPW9";
    RouteSignature.creatorAccountGetStatus = "=)1;lukruUtUJ5M)F9)k";
    RouteSignature.creatorAccountGetTos = "z@$&Csv)*`PjBMn(TX>v";
    RouteSignature.creatorAccountPromoteToPrimaryWorks = "sb!2$K7b`ytKIpxq3h)Z";
    RouteSignature.creatorAccountRemoveWorkFromWorksFeed = "I}14;0G-VlXL^s(`+<Bu";
    RouteSignature.feedChangePos = "RvXiS-?q27I=6%zHeA8~";
    RouteSignature.feedCopyHashtag = "UWehocpLp5lFzBfhfOm;";
    RouteSignature.feedCreate = "$|8Saw?E~y9oCvaMCOc7";
    RouteSignature.feedCreateHashtag = "5|!dte*3&}S;&gK*V%S!";
    RouteSignature.feedCreateStream = "1SuUbO#@>1>)(Uc<(sU1";
    RouteSignature.feedDefaultEphemeralityGet = "k|Az%xPau5xN8r$2yk{Q";
    RouteSignature.feedDefaultEphemeralitySet = "$aZ-nJ!VtAKt~$zx;$8-";
    RouteSignature.feedDelete = "2Pxn+(RrkE&>FGV+iBfg";
    RouteSignature.feedEntryAdd = "JAP#n+Z`G1-8tDY?2c9Q";
    RouteSignature.feedEntryAddEgo = "hDmUxN7}zz3}3h?U00dS";
    RouteSignature.feedEntryAddPost = "8qp!yiuzZ}c}E$d9NWNo";
    RouteSignature.feedEntryAddReport = "f;)>W2CJ5IFG1MF3i9=R";
    RouteSignature.feedEntryAddVideo = "&?FdSm|&gM*oq$Rl7B={";
    RouteSignature.feedEntryArchive = "i6hnf_temzS9@dN`-z~F";
    RouteSignature.feedEntryArchive2 = "sW33B!u503<RccR(5&(^";
    RouteSignature.feedEntryContentGet = "+1{P?4j~%0Rh+rPZfTj8";
    RouteSignature.feedEntryContentRemove = "I}14;0G-VlXL^s(`+<Bu";
    RouteSignature.feedEntryContentSet = "Nq87@LCBLun};J$8D04Y";
    RouteSignature.feedEntryContentSetStatus = "EEM7*HGT8x^7+&j^M@+Z";
    RouteSignature.feedEntryCpcUpdate = "ul|YSB6wVy|C}B(G96}j";
    RouteSignature.feedEntryFeedbackEffects = "8~CF?@pptg%+pu%U2!Hw";
    RouteSignature.feedEntryGet = "nRTy8R|CV`G4HR285_=T";
    RouteSignature.feedEntryGetAgentInfo = "jOpI?hNI&g3_ILlr8gf}";
    RouteSignature.feedEntryGetCreators = "t2dVh2+P1$pi^0j@L!`2";
    RouteSignature.feedEntryGetUrlForSharing = "B91_wYiDW;J1XbkeyepZ";
    RouteSignature.feedEntryHashtagAdd = "6j~Dw-X#{8cJ8tUgz-nE";
    RouteSignature.feedEntryHashtagRemove = "V-9{j1Y6}h8Nl_4_|CiM";
    RouteSignature.feedEntryHashtagSetNatural = "LoRt;VNfOe&>0Omr)<Y~";
    RouteSignature.feedEntryHashtagUnsetNatural = "-ZSy!BkH#$xflU~gBzM+";
    RouteSignature.feedEntryIter = "b1iiM6ck2EVk*0B4nx_v";
    RouteSignature.feedEntryIterNext = "((eTTZ+lZA0{`Q$pL+Fb";
    RouteSignature.feedEntryLessLikeThis = "FfW;;NP5m&yT>N>A_by&";
    RouteSignature.feedEntryMarkProgress = "o?#R5moRL0rlj64F*F``";
    RouteSignature.feedEntryMoreLikeThis = "FfW;;NP5m&yT>N>A_by&";
    RouteSignature.feedEntryPrune = "F;8R!P#e|C#TrO6UK`|E";
    RouteSignature.feedEntryRefresh = "lwZ+l-~EWue)lqmW{(2e";
    RouteSignature.feedEntryRemove = "I^I4xe%gez|DGIwl!Dul";
    RouteSignature.feedEntryRemoveVia = "7;VvPRhz!ZTtUn4;KCoP";
    RouteSignature.feedEntryReply = "ksUs0bIEmMI++WF=)TEw";
    RouteSignature.feedEntryReqExtractMetadata = "e`TH}pV<9HG!~Axd5YoM";
    RouteSignature.feedEntrySeen = "zWV0wM)qD%2;kp~&~UJN";
    RouteSignature.feedEntrySetAgentInfo = "4Vh{wfig;g-fP#(RRRxw";
    RouteSignature.feedEntrySetStaffOverrides = "^>gbEpe2==gj2UL#2Z)K";
    RouteSignature.feedEntryUnarchive = "lwZ+l-~EWue)lqmW{(2e";
    RouteSignature.feedEntryUpdatePost = "5UYN-($04&idVquzIY*h";
    RouteSignature.feedFollow = "EF<I9MZ9KX4R$Yt+FJQi";
    RouteSignature.feedFollowRss = "97Zdv{knWrIDvM)B~__P";
    RouteSignature.feedForwardCreate = "?}P`Du`pp|=14f=12mAA";
    RouteSignature.feedForwardDelete = "wge0olfZElvfi<#efFvz";
    RouteSignature.feedForwardListDownstream = "d1!FCr!}4-w%Up6oDaPr";
    RouteSignature.feedForwardListUpstream = "d1!FCr!}4-w%Up6oDaPr";
    RouteSignature.feedGet = "n@$&23jkstD+q45K(8t=";
    RouteSignature.feedGetAcl = "Fgv1*wn_>6Z=1MP?Pe<0";
    RouteSignature.feedGetAgentTopicTaxonomy = "Rpd7xRlst`(aS)GdU5Li";
    RouteSignature.feedGetUpstreamRss = "fkZzZry%ivUCcjcwA1%-";
    RouteSignature.feedGroupAddEmbed = "GNU-YinAZN{N041`e_^N";
    RouteSignature.feedGroupAddFeed = "7xrm@@e@E9Z{yt71dOk9";
    RouteSignature.feedGroupAddSubGroup = "XcopMF`%GxG03ac8(?e5";
    RouteSignature.feedGroupCreate = "<%&D+%?$YW2mUS@nk{%^";
    RouteSignature.feedGroupGet = "$W)H&ru_|)WAx8TGU|Kj";
    RouteSignature.feedGroupGetAppConfig = "#XQ8r2Ajuw68Aa-O;Nif";
    RouteSignature.feedGroupRemoveEmbed = "2`hP3lD-Hujf@-x_#-xi";
    RouteSignature.feedGroupRemoveFeed = "2`hP3lD-Hujf@-x_#-xi";
    RouteSignature.feedGroupRemoveSubGroup = "0+;GIXY|C}p|;A>cVNY1";
    RouteSignature.feedGroupSearch = "Fo1}S`0JH&g`70K0|3|j";
    RouteSignature.feedIter = "LWbN3dPguj_P3zNt7y<i";
    RouteSignature.feedIterNext = "h;}g;voX9C>x_VOKI?Y|";
    RouteSignature.feedNotificationPolicyGet = "=P(y)m8L@4GU-2935ois";
    RouteSignature.feedNotificationPolicySet = ">&3MGp=E5Jg-HOsZ<k8L";
    RouteSignature.feedOnboardingTopics = "i#ZpcZSa8`w%g4Z0aH_7";
    RouteSignature.feedPopular = "ztzRoUc(kcyKrTA@MZ6X";
    RouteSignature.feedPopular2 = "m0VHG0;jx%1GYv?ym+hS";
    RouteSignature.feedPopular3 = "ocWV{11?&=;o19ZP2lRz";
    RouteSignature.feedRename = "U+sF8&cUvTt|Uo}WJ1CK";
    RouteSignature.feedSetAcl = "%p<|X|6FiS{;Y=?gqJQC";
    RouteSignature.feedSetDisplayMode = "A!N8xP+9KmBlg~2gj&`&";
    RouteSignature.feedSetImage = "xx4zU`TLV+?*mu-D1CB^";
    RouteSignature.feedSetPrimaryDomain = "`D<1zaOu-c)I_=<*@!*g";
    RouteSignature.feedSetPublisher = "!+q%nj#hOX<KKCxMPrvy";
    RouteSignature.feedSetStyle = "MUHi|fV`Pr^Rb%{gw-YZ";
    RouteSignature.feedUnfollow = "71!~lWXP@}3F8iNsq<WV";
    RouteSignature.feedUpdateBlurb = "SO7FkaPct`i)B`;hFPO)";
    RouteSignature.feedUpdateDefaultOrdering = ")}Gh}_LZU#=54L+QI8@D";
    RouteSignature.feedUpdatePermPublicRead = "*kh=5U~KNhtTRn0L{hG`";
    RouteSignature.inboxCreateSharedFeed = "Na$kd|1?c}asoXKTHRs~";
    RouteSignature.inboxGetShareSuggestions = "k`lQnOR$m8|Cx-l@(})i";
    RouteSignature.inboxGetUnread = "&J@ha>h)9p|DL?pNABG!";
    RouteSignature.inboxGetUnreadCount = "_0r0#HZVhnPS8tT{?hCT";
    RouteSignature.medialibAutoDeposit = "U+mFHD`+Ky891V&kus!X";
    RouteSignature.medialibUploadDeposited = "IF0gCe-OZXI)aEj8%;+6";
    RouteSignature.medialibUploadSetCpcVideoTarget = "Jc#BrjtC=E<`BOO7bk<E";
    RouteSignature.medialibUploadStart = "uV;ZOY?6b=SF0F~L+x0X";
    RouteSignature.newsfeedEntryIter = "LtkL(;60b+;~6V^G+qFx";
    RouteSignature.newsfeedEntryIterNext = "?lfUarW;UWUF~iRTCe(^";
    RouteSignature.newsfeedEntryIterAsUser = "RQ%SMo13r$X`yDJF$uZ#";
    RouteSignature.newsfeedEntryIterDefault = "LtkL(;60b+;~6V^G+qFx";
    RouteSignature.newsfeedEntryIterInbox = "LtkL(;60b+;~6V^G+qFx";
    RouteSignature.newsfeedFilterGet = "6}tqSr$WcvX8SLz5@)3&";
    RouteSignature.newsfeedFilterSet = "$A-Z-SP6S6o;>UZrSH)G";
    RouteSignature.pdataGetNewsfeedTopicStats = "rb8Ia0T<<>`j7%fO3wYB";
    RouteSignature.pdataGetNewsfeedUserStats = "*#;4$`!`~ScL3%#vvNSE";
    RouteSignature.pdataGetUserNewsfeedActivity = "e?aM)Mv+aiC>agaG7s(E";
    RouteSignature.prismAudienceCreate = "EHGEN9nPDO-ZYBg3ucow";
    RouteSignature.prismAudienceGet = "P%>zy7irp@6*(|y^0}xr";
    RouteSignature.prismAudienceSet = "XV18JE$PNWJrClU=x^-i";
    RouteSignature.prismCreate = "1uCl0e@Z;`;(UgaZYv2Y";
    RouteSignature.prismGet = "r!+Q2wjV$pE8yVZwYljd";
    RouteSignature.prismOrphan = "Rfp6ItXap<TRyhPO2EV^";
    RouteSignature.prismSet = "4WG<8X5=i3$E#L@eg4AN";
    RouteSignature.rssAddSource = "$|ZlUgFEs~G+ATUM6LMg";
    RouteSignature.rssAddUrlPrefix = "nLfK3T;{&5ZWM!OIBFh)";
    RouteSignature.rssGetCpcSample = "oZY!ZxDYt8?Fs+@I}E;g";
    RouteSignature.rssGetHomepageScoringDryRun = "Hl=EP2j+-W+R^txFF8U^";
    RouteSignature.rssGetRssInfo = "KY3j;-m2eD#W<-K_!Z~3";
    RouteSignature.rssGetSource = "zLIiv0a4*^?r}%|GXf=-";
    RouteSignature.rssRemoveUrlPrefix = "2L!k|E}rIFjT+rDv9ch|";
    RouteSignature.rssScan = ">LI~1is0{NA^G~;KKoSo";
    RouteSignature.rssSchedulePump = "0(5YBrXq-X1);jECLqG2";
    RouteSignature.rssSetCpcPolicy = "{d{g%Xy)UZ8jui3HZ!Z)";
    RouteSignature.rssSetEnable = "MFd_vbyPWHLk&r4E?=^!";
    RouteSignature.rssSetHomepageUrl = "<fN<3w61$Kqg4QaE+%@I";
    RouteSignature.rssSetInjectMetadata = "@?hr<Yg4DT`*OTW%hO%@";
    RouteSignature.rssSetPeriod = "3Z!#KFy-0Us9-sFfPGUu";
    RouteSignature.rssSetUseCpc = "mqzC%kaO9!H*V8~H<oAH";
    RouteSignature.rssSetUseHomepageForScoring = "c5Id3NEC7np)VZzb@`3r";
    RouteSignature.searchOmni = "4O5x$ioLuR4$NuJQ*OPq";
    RouteSignature.searchQueryAuthors = "u~<Cw1nw#kxvE^ii4F7a";
    RouteSignature.searchQueryTopics = "|A}d{Q|NEwm7FaZMKBmc";
    RouteSignature.staffOpAutoCpcForUrl = "Y@Bbpx6@jB{$CQgax;)J";
    RouteSignature.staffOpDomainPolicyGet = "28aUv%?~6F2A&%LP@RNI";
    RouteSignature.staffOpDomainPolicySet = "rze6kG)XRYjtp5~lyzsk";
    RouteSignature.staffOpGetTopicStats = "1-_4JQgsyzN|C){?)KM6";
    RouteSignature.staffOpStimulusAssignCanonical = "VU3`I627GCjx31p>o%`$";
    RouteSignature.staffOpStimulusCreditCreator = "NRQmP!M?@}ZcE`GiaNTQ";
    RouteSignature.staffOpStimulusCreditNewCreator = "$nyD7+&ScDbw_YN275wW";
    RouteSignature.staffOpStimulusCreditUser = "U4I2EI_YK=MwHJWfA|&B";
    RouteSignature.staffOpStimulusInjectMetadata = "@CaF3j(ol{Gi!o9r7QZ-";
    RouteSignature.staffOpStimulusRemoveInjectedMetadata = "%x1IH6ysC;nr;>{DJeSj";
    RouteSignature.staffOpStimulusUnassignCanonical = "O{m8-+<ZbQY0ry3qHvdm";
    RouteSignature.stimulusAppVideoRetranscode = "r*G}O5HI@5NX<ULjm1<i";
    RouteSignature.stimulusDiscussionAdd = "yM-Q4i9qU2s05R*((QZw";
    RouteSignature.stimulusDiscussionHide = "yM-Q4i9qU2s05R*((QZw";
    RouteSignature.stimulusEgoIter = "W)A)e%jf>|Z;y<&c~N~)";
    RouteSignature.stimulusEgoIterNext = "fjn?(rc<IEf9+Jfx1!j1";
    RouteSignature.stimulusEphemeralitySet = "kI7^%0feFot~Yjz8Fx8&";
    RouteSignature.stimulusGet = "an|=sH6)yFg)sesHAq2w";
    RouteSignature.stimulusGetAppVideo = "CQ85DAX}Bw`q1L&Qm`b2";
    RouteSignature.stimulusGetCommentary = ")1R{^pfYEY<wID#dbH^@";
    RouteSignature.stimulusGetRss = "J3r&T<7rb=$f@b8CI)DX";
    RouteSignature.storyAiApplyAiRecs = "y7O*UgQ-;0D(2V<5^m$o";
    RouteSignature.storyAiGetRelatedWikis = "LkV1IO(mv>o6+P;eFJ5F";
    RouteSignature.storyAiPrompt = "r(5rz`Rik?sn(*35o8`)";
    RouteSignature.storyAiPromptCompareEntry = "*nASb$$-y}yGI$ApG|Ni";
    RouteSignature.storyAiRuleBlockWiki = "pL1Q_^nkiV-NNixdHc9*";
    RouteSignature.storyAiRuleGetDoubleCheckPrompt = "S+#{-4%24%MG(ySypk^)";
    RouteSignature.storyAiRuleSetDoubleCheckPrompt = "uO6BlmgozyqS`1|Ce%@@";
    RouteSignature.storyAiSummaryGenerate = "jj8XdchnfRhP`O?qLhzT";
    RouteSignature.storyAiSummaryGet = "LT_k78R$>appG`$OVv_F";
    RouteSignature.storyAiSummaryRemove = "I}14;0G-VlXL^s(`+<Bu";
    RouteSignature.threadCommentAdd = "p;@V0XqX)4Ns!WDb$Jm;";
    RouteSignature.threadCommentDelete = "FQNS_b&e|<R6TpodSk~Z";
    RouteSignature.threadCommentDownvote = "iFr5Xk|s>Ka#`uxK|8rw";
    RouteSignature.threadCommentUnvote = "iFr5Xk|s>Ka#`uxK|8rw";
    RouteSignature.threadCommentUpvote = "iFr5Xk|s>Ka#`uxK|8rw";
    RouteSignature.threadGetBreadcrumb = "rCfP9QBs1b8zvsy3sAQT";
    RouteSignature.threadGetReplies = "YW;3mm(RQV(}YMGjTP$L";
    RouteSignature.threadGetSiblings = "(Ne)pni7P~KN2RX^#p7h";
    RouteSignature.threadGetTree = "j5)}+$j3a4eqI0nTK=;K";
    RouteSignature.threadSeen = "zGSc<Q4tkwzq}9ypdyE`";
    RouteSignature.topicAssociate = "eSI05+6?^?hwWs!97tI1";
    RouteSignature.topicComputeRelatedToFeed = "N(Ob5?;t4pa~~17b5EJ?";
    RouteSignature.topicCreateFromWiki = "Rfo>>SBvHr8GVUg^jJl*";
    RouteSignature.topicDisassociate = "(y%O4)+XXPTx+x^<j0=U";
    RouteSignature.topicGetCotopics = "gF6H_r>(PHoWN|8Ge}r*";
    RouteSignature.topicGetRelatedToFeed = "h4C_wy!jB`36vJQfP(A>";
    RouteSignature.topicGetWikiUrl = "vfxb*LcDzNz#owF$fao)";
    RouteSignature.topicRecommend = "P@=H&l5=3RqKYHXiyQDb";
    RouteSignature.userGet = "E6N0^501r=Z=4suxgANk";
    RouteSignature.userGetRecentEmails = "Qtbg2Ad=LD-T*XJDyj3S";
    RouteSignature.userGetRecentPushNotifs = "!hkJ^Yw;p|(3(m1u7PZz";
    RouteSignature.userGetUserInfoForAgent = "pi-itGXK{Fp4)X-5-Y8B";
    RouteSignature.userGiveFeedback = ";D`sb|Cf3Cn*tsH|M5G3";
    RouteSignature.userMe = "$0UFI+vlx!wCcaAHT7?8";
    RouteSignature.userMeInternal = "$0UFI+vlx!wCcaAHT7?8";
    RouteSignature.userSendVerificationEmail = "0K;ttm9}nnp*QH-ih#i;";
    RouteSignature.userUpdateBio = "k#J=yp3ldI?>8xwh0j|k";
    RouteSignature.userUpdateName = "Y~&T{Dwq=kU3BKJDEs#t";
    RouteSignature.userUpdateWebsite = "kyT?y-+XD<ki|1rLOgpj";
})(RouteSignature = exports.RouteSignature || (exports.RouteSignature = {}));
